import { RequestedDoc } from "../../../certificates/models/certificates.interfaces";
import { requestedDocsAtom, themeAtom, userAtom } from "../../../shared/atoms";
import Avatar from "../../../shared/components/Avatar";
import { toastError } from "../../../shared/components/ToastContainer";
import { TUser } from "../../../shared/types";
import { SelectionConfirmStepProps } from "../../models/document-request.models";
import RequestDocumentSelectionRow from "./RequestDocumentSelectionRow";
import { useAtom, useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const SelectionConfirmStep: React.FC<SelectionConfirmStepProps> = ({ vessel, isSending }) => {
  const theme = useAtomValue(themeAtom);

  const [documentsRequested, setDocumentsRequested] = useAtom(requestedDocsAtom);
  const user: TUser | undefined = useAtomValue(userAtom);

  const handleRemoveDocument = (docToRemove: RequestedDoc) => {
    if (documentsRequested.length === 1) {
      toastError("At least one document must be selected");
      return;
    }
    const filteredDocuments = documentsRequested.filter((doc) => doc.name !== docToRemove.name);
    setDocumentsRequested(filteredDocuments);
  };

  return (
    <div className={twMerge("flex flex-1 flex-col", theme.uwhcAssistant.text)}>
      <p className="mb-6 text-2xl font-semibold">Confirm selection</p>
      <p className="mb-6">You're about to send a request for the following documents. Please, confirm the selection.</p>

      <div
        className={twMerge(
          "flex min-h-[240px] w-[480px] flex-col gap-2 overflow-y-auto rounded-lg border bg-[#E9F4F3] p-4",
          theme.headerComponent.notifications.itemBackground,
          theme.uwhcAssistant.border,
        )}
      >
        <p className={twMerge("text-xs", theme.headerComponent.notifications.iconShape)}>Documents requested</p>
        {documentsRequested?.map((doc) => (
          <RequestDocumentSelectionRow
            key={doc.name}
            document={doc}
            disabled={isSending}
            onRemove={handleRemoveDocument}
          />
        ))}
        <div className="mt-auto flex justify-between">
          <div className="flex flex-col gap-2">
            <p className={twMerge("text-xs", theme.headerComponent.notifications.iconShape)}>Vessel name</p>
            <p className="text-sm">{vessel.name}</p>
          </div>

          <div className="flex flex-col gap-2">
            <p className={twMerge("text-xs", theme.headerComponent.notifications.iconShape)}>Vessel code</p>
            <p className="text-sm">{vessel.code}</p>
          </div>

          <div className="flex flex-col gap-2">
            <p className={twMerge("text-xs", theme.headerComponent.notifications.iconShape)}>Requested by</p>
            {user && <Avatar name={user.name} textClasses="text-sm" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectionConfirmStep;
